const TRANSITION_DURATION = 100;
const sheetCls = "_n29s19hztvl";
const transitionCls = "_n29t1dcrcdx";

export { TRANSITION_DURATION, sheetCls, transitionCls };
import "./Sheet.style.linaria.module.css";
//# sourceMappingURL=Sheet.style.js.map
